import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { SiteMetadata, HelmetDetails } from '@luigiclaudio/ga-baseline-ui/helpers';
import landingPageSeo from '../data/landingPageSeo';
import { siteUrl, canonicalUrl, isNoIndexPath } from '../utils/seoUtils';

const SiteSeo = ({ pathname, pagePath, seo }) => {
    const intl = useIntl();
    const messageKey = landingPageSeo[pathname.split(/[?#]/)[0].replace(/\/+$/, '')];
    const canonicalPath = seo?.canonicalPath || pathname;
    return (
        <>
            <SiteMetadata
                canonical={canonicalUrl(canonicalPath)}
                siteName={intl.formatMessage({ id: 'siteName' })}
                siteUrl={siteUrl}
                siteIcon="/media/logo-dark.png"
                siteDescription={intl.formatMessage({ id: 'siteLaunch.helmet.description' })}
                twitterHandle={intl.formatMessage({ id: 'twitterHandle' })}
                siteImage={`${siteUrl}/media/og-image.png`}
            />
            <HelmetDetails
                title={
                    seo?.title ||
                    (messageKey
                        ? intl.formatMessage({ id: `${messageKey}.helmet.title` })
                        : undefined)
                }
                description={
                    seo?.description ||
                    (messageKey
                        ? intl.formatMessage({ id: `${messageKey}.helmet.description` })
                        : undefined)
                }
                keywords={
                    messageKey ? intl.formatMessage({ id: `${messageKey}.keywords` }) : undefined
                }
                robots={
                    seo?.robots ||
                    (isNoIndexPath(pathname) || isNoIndexPath(pagePath)
                        ? 'noindex, follow'
                        : 'index, follow')
                }
            />
        </>
    );
};

SiteSeo.propTypes = {
    pathname: PropTypes.string.isRequired,
    pagePath: PropTypes.string,
    seo: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        canonicalPath: PropTypes.string,
        robots: PropTypes.string,
    }),
};
SiteSeo.defaultProps = { pagePath: undefined, seo: undefined };

export default SiteSeo;
